import { Injectable } from '@angular/core';
import { CompanyDTO, CompanyToInviteDTO, CPVDTO } from '../../api/plyca-dtos-v2';
import { FormConfig, FormConfigHelper } from '../../components/forms/form.objects';
import { formElementComponent } from '../../components/forms/formElement.component';

@Injectable()
export class ProcurementProjectAYMADMINORValidations implements FormConfigHelper {
  constructor() { }

  public minorChangeValueDataCession(model: any) {
    if (!model.breakdownLot.totalLots.dataCession) {
      model.breakdownLot.totalLots.dataCessionDesc = '';
    }
  }

  public minorChangeValueDataOutsourcing(model: any) {
    if (!model.breakdownLot.totalLots.dataOutsourcing) {
      model.breakdownLot.totalLots.dataOutsourcingDesc = '';
    }
  }


  public registerFunctions(frmConfig: FormConfig): void {
    // FUNCIONES PARA FICHA EXPEDIENTE CONTRATOS BASADOS //
    frmConfig.functions.push({
      identifier: 'minorChangeValueDataCession',
      fn: this.minorChangeValueDataCession.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'minorChangeValueDataOutsourcing',
      fn: this.minorChangeValueDataOutsourcing.bind(this)
    });



  }
}
